import { GoogleSheetsReconnectButton } from './GoogleSheetsReconnectButton';
export const GoogleSheetsReconnectionConfig = {
  reconnectButton: GoogleSheetsReconnectButton
};